import React from 'react';

export const SuccessNotification = (toast: any, NotificationData: any, displayTime?: any) => {
  const { description, action, ...rest } = NotificationData;

  const normalizedDescription = (
    <div className="flex w-full items-start gap-2 text-left">
      {action && <div className="shrink-0">{action}</div>}
      <div className="text-sm leading-5" dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );

  return toast({
    className: 'bg-[#E7F6ED] px-4 py-4 text-black font-medium flex items-start text-left',
    duration: displayTime ? displayTime : 3000,
    description: normalizedDescription,
    ...rest,
  });
};

export const ErrorNotification = (toast: any, NotificationData: any) => {
  const { description, action, ...rest } = NotificationData;

  const normalizedDescription = (
    <div className="flex w-full items-start gap-2 text-left">
      {action && <div className="shrink-0">{action}</div>}
      <div className="text-sm leading-5" dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );

  return toast({
    className: 'bg-[#FFEBEB] px-4 py-4 text-black font-medium flex items-start text-left',
    duration: 3000,
    description: normalizedDescription,
    ...rest,
  });
};
